import * as serverApi from './server'

export const getAll = (queryParams) => serverApi.get('/v3/alerts', queryParams)

export const markAsSeen = ({ alertId }) => serverApi.put(`/v3/alerts/${alertId}`)
